import React, { useEffect, useState } from "react";
import { SubTitle } from '../../../components/text'
import { Flex } from "../../../components/containers";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { InputHeader, StyledDatePicker } from "./shared";
import { updatePickupTime, updateDropoffTime } from '../../../redux/reducers/deeleeoReducer'
import { connect } from "react-redux";
import Grid from '@material-ui/core/Grid';
import styled from "styled-components";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';


import { validatePickupTime, validateDropoffTime, validatePickupWindowTime, validateDropoffWindowTime } from "../../../redux/reducers/validationReducer";
// import { TimeField } from "./PickupHourSelector";
import DateTimePicker from "../../../components/DateTimePicker";
import moment from "moment";
import { useRecoilState } from "recoil";
import { isInterCity } from "../../../App";
import axios from "axios";
import { getURI } from "../../../helpers/apiHelpers";
import GenericModal from "../../Dashboard/components/GenericModal";






// const Dash = styled.div`
//   ${tw`text-fontBlue`}
// `

const StyledLabel = styled(FormControlLabel)`
  .MuiTypography-body1 {
    font-size: 14px;
    font-family: Montserrat;
    color: #3d405b;
  }
`



export const RadioOption = (props) => {
  const { value, label, selectedValue, isDisabled } = props
  return (
    <StyledLabel value={value} control={<Radio disabled={isDisabled} checked={value === selectedValue} />} label={label}
    />
  )
}

// get nearest round up quarter of hour (also use this to get +2hours)
export const roundTime = (time, minutesToRound) => {
  // console.log('roundtime', time, minutesToRound);

  let [hours, minutes] = time.split(':');
  hours = parseInt(hours);
  minutes = parseInt(minutes);

  // Convert hours and minutes to time in minutes
  time = (hours * 60) + minutes;

  let rounded = Math.ceil(time / minutesToRound) * minutesToRound;
  let rHr = '' + Math.floor(rounded / 60)
  let rMin = '' + rounded % 60

  return rHr.padStart(2, '0') + ':' + rMin.padStart(2, '0')
}

export const getFutureTime = (base_date, base_time, add_minute) => {
  var converted_time = new Date(base_date + ' ' + base_time);
  var future_time_string = moment().toDate();
  future_time_string.setTime(converted_time.getTime() + (add_minute * 60 * 1000))
  return future_time_string.getHours() + ':' + ((future_time_string.getMinutes() < 10 ? '0' : '') + future_time_string.getMinutes())
}

/**
   * Gets a javascript date combining the selected pickup date and the time passed as parameter
   * @param {string} time 
   * @returns Date
   */
export const getDateWithTime = (date,time) => {
  let result = moment(date);
  if (time) {
    const timeString = moment(time, 'HH:mm');

    result.set({
      hour: timeString.get('hour'),
      minute: timeString.get('minute'),
      second: timeString.get('second')
    });
  }


  const target = result.toDate();
  return target;
}

export const isTodaySelected = (date) => {
  const format = 'YYYY-MM-DD';
  const now = moment();
  const selected = moment(date);

  return now.format(format) === selected.format(format);

}

function PickupDropoffTimeSection(props) {
  // const pickupOptions = {
  //   READY_NOW: '1',
  //   SCHEDULE: '2',
  //   URGENT: '3'
  // }

  const dropoffOptions = {
    SAME_DAY: '1',
    SCHEDULE: '2',
    IMMEDIATELY: '5'
  }

  const {
    validatePickupTime, validateDropoffTime, validatePickupWindowTime, validateDropoffWindowTime, updateDropoffTime, updatePickupTime,
    // eslint-disable-next-line no-unused-vars
    pickup_value, dropoff_value, validation, isValet, userData, deeleeo_data, pickupData, dropoffData, setIsSpecialTiming, isBatch
  } = props;

  // console.log('validation old: ', validation);

  const [interCity, setInterCity] = useRecoilState(isInterCity);

  const [state, setState] = useState({
    pickupTimeValue: pickup_value,
    dropoffTimeValue: dropoff_value,
    isDropoffDateDisable: dropoff_value.dropoff_type === dropoffOptions.SCHEDULE ? false : true,
    isPickupStartTimeDisable: false,
    isPickupEndTimeDisable: false,
    isDropoffTimeDisable: dropoff_value.dropoff_type === dropoffOptions.SCHEDULE ? false : true,
    isDropoffTimeHidden: dropoff_value.dropoff_type === dropoffOptions.SAME_DAY ? true : false,
    pickupTimeRadio: '',
    dropOffTimeRadio: '',
    currentPickupDate: moment().toDate(),
    dropOffTimes: [],
    intercityContent: '',
    pudoTimes: [],
    isIntercityDown: false,
    isModalOpen: false,
    error: validation,
    distanceInKm: 0,
    specialTiming: false,
  });

  // console.log(userData);


  const setPickupTimeValue = (data) => {
    setState(state => ({ ...state, pickupTimeValue: data }));
  }

  const setDropoffTimeValue = (data) => {
    setState(state => ({ ...state, dropoffTimeValue: data }));
  }

  const setPickupTimeRadio = (data) => {
    setState(state => ({ ...state, pickupTimeRadio: data }));
  }

  const setDropOffTimeRadio = (data) => {
    setState(state => ({ ...state, dropOffTimeRadio: data }));
  }

  const setCurrentPickupDate = (data) => {
    setState(state => ({ ...state, currentPickupDate: data }));
  }

  const setDropOffTimes = (data) => {
    setState(state => ({ ...state, dropOffTimes: data }));
  }

  const setInterCityContent = (data) => {
    setState(state => ({ ...state, intercityContent: data }));
  }

  const setPudoTimes = (data) => {
    setState(state => ({ ...state, pudoTimes: data }));
  }

  const setIsIntercityDown = (data) => {
    setState(state => ({ ...state, isIntercityDown: data }));
  }

  const setIsModalOpen = (data) => {
    setState(state => ({ ...state, isModalOpen: data }));
  }

  const setError = (data) => {
    setState(state => ({ ...state, error: data }));
  }

  const setDistanceInKm = (data) => {
    setState(state => ({ ...state, distanceInKm: data }));
  }

  const setSpecialTiming = (data) => {
    setState(state => ({ ...state, specialTiming: data }));
  }




  /**
   * No need to be state managed
   */
  // let pickupTimes = [];
  // const setPickupTimes = (data) => {
  //   pickupTimes = data;
  // }

  useEffect(() => {

    const payload = {
      originLat: parseFloat(`${pickupData.latitude}`), originLon: parseFloat(`${pickupData.longitude}`), destinationLat: parseFloat(`${dropoffData.latitude}`), destinationLon: parseFloat(`${dropoffData.longitude}`)
    };
    // console.log('interCity payload', payload);

    if (payload.originLat !== 0 && payload.originLon !== 0 && payload.destinationLat !== 0 && payload.destinationLon !== 0) {
      axios.post(getURI('/api/web/deeleeo/isIntercity'), payload)
        .then(data => {
          // console.log('data', data);
          setInterCity(data.data === 1);
          getPudo();
        })
    }




    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pickupData, dropoffData]);


  const getPudo = () => {

    const payload = {};
    payload.api_key = userData.apiCode;
    payload.lat = dropoffData.latitude;
    payload.lon = dropoffData.longitude;
    payload.local_intercity = interCity ? 1 : 0;

    //  console.log('payload', payload);
    if (payload.lat && payload.lat !== 0 && payload.lon && payload.lon !== 0) {
      //  console.log('payload passed', payload);

      axios.post(getURI('/api/web/get-custom-times-from-coordinate'), payload)
        .then((data) => {
          setPudoTimes(data.data.data);
        })
        .catch(e => {
          setPudoTimes([]);
          if (!state.isIntercityDown) {
            // alert(e.response.data.message);
            setInterCityContent(e.response.data.message);

            setIsIntercityDown(true);
            setIsModalOpen(true);
          }
        })
    }

  }


  useEffect(() => {
    // console.log('interCity down', isIntercityDown);    
    getPudo();
  }, [userData.apiCode, state.pickupTimeValue, state.dropoffTimeValue, interCity, state.isIntercityDown, dropoffData.latitude, dropoffData.longitude]);

  useEffect(() => {
    // getDistanceInKm

    const payload = {
      originLat: parseFloat(`${pickupData.latitude}`), originLon: parseFloat(`${pickupData.longitude}`), destinationLat: parseFloat(`${dropoffData.latitude}`), destinationLon: parseFloat(`${dropoffData.longitude}`)
    };

    if (payload.originLat !== 0 && payload.originLon !== 0 && payload.destinationLat !== 0 && payload.destinationLon !== 0) {
      axios.post(getURI('/api/web/deeleeo/getDistance'), payload)
        .then(data => {
          // console.log('data', data);
          setDistanceInKm(data.data);
        })
    }


  }, [dropoffData.latitude, dropoffData.longitude, pickupData.latitude, pickupData.longitude]);



  useEffect(() => {
    setError(validation);
  }, [validation])


  useEffect(() => {
    const initialValue = moment().add(30, 'm');
    setCurrentPickupDate(initialValue.toDate());

    /**
     * Clean the status to force validation
     */
    setPickupTimeValue({
      ...state.pickupTimeValue,
      pickup_early_datetime: '',
      pickup_later_datetime: ''
    });


    setDropoffTimeValue({
      ...state.dropoffTimeValue,
      dropoff_early_datetime: '',
      dropoff_later_datetime: ''
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  

  const dropoffDatetimeHandle = (value, is_early_datetime) => {
    if (is_early_datetime) {
      setDropoffTimeValue({ ...state.dropoffTimeValue, dropoff_early_datetime: value });
    } else {
      setDropoffTimeValue({ ...state.dropoffTimeValue, dropoff_later_datetime: value });
    }
  };

  const pickupDateChangeHandle = (full_date) => {
    var selected_date = new Date(full_date);

    setPickupTimeValue({
      ...state.pickupTimeValue,
      pickup_date: selected_date.toString()
    })

    setDropoffTimeValue({
      ...state.dropoffTimeValue,
      dropoff_date: selected_date.toString()
    })
  }

  

  const pickupTimeHandle = (event) => {
    // console.log(event);
    // console.log('handling pickup time');
    // console.log('pickup value');
    // console.log(pickup_value);
    setPickupTimeRadio(event.target.value);
    /**
     * Always clear the drop off radio
     */
    setDropOffTimeRadio('');

    let timeOption = null;




    if (!timeOption) {
      const getIndex = parseInt(event.target.value.split('-')[1]);
      timeOption = state.pudoTimes[getIndex].pickup_time[0];
      setDropOffTimes(state.pudoTimes[getIndex].dropoff_time);
      if (isNaN(getIndex)) return;

    }

    // console.log(timeOption);


    /**
     * This is an urgent guy
     */
    if (timeOption && timeOption?.early_time === '' && timeOption?.later_time === '') {
      const current = moment().toDate();
      const start_time = roundTime(current.getHours() + ':' + current.getMinutes(), 30);
      // update pickup
      setPickupTimeValue({
        ...state.pickupTimeValue,
        pickup_type: '3',
        pickup_early_datetime: start_time,
        pickup_later_datetime: start_time
      });

      const next_2h_time_string = getFutureTime(current.toLocaleDateString(), start_time, 120);
      setDropoffTimeValue({
        ...state.dropoffTimeValue,
        dropoff_type: '3',
        dropoff_early_datetime: start_time,
        dropoff_later_datetime: next_2h_time_string
      })
    } else {
      // console.log('in the else');

      setPickupTimeValue({
        ...state.pickupTimeValue,
        pickup_type: '2',
        pickup_early_datetime: timeOption.early_time,
        pickup_later_datetime: timeOption.later_time
      });

      setDropoffTimeValue({
        ...state.dropoffTimeValue,
        dropoff_type: '2',
        // dropoff_date: pickupTimeValue.pickup_date,
        dropoff_early_datetime: timeOption.later_time,
        // dropoff_later_datetime: timeOption.later_time
      })
    }




  }

  const dropOffTimeHandle = (event) => {

    setDropOffTimeRadio(event.target.value);

    let timeOption = null;
    try {
      timeOption = state.dropOffTimes.filter((e, i) => {
        return parseInt(event.target.value) === i;
      })[0];
    } catch (e) {

    }

    // console.log('dropoff', timeOption);

    setSpecialTiming(false);
    setIsSpecialTiming(false);




    /**
     * Some custom drop offs may be next day delivery.
     * Here we are adding an extra day from the pickup date.
     */
    let dropOffDate = state.pickupTimeValue.pickup_date;

    if (timeOption.is_next_day_do) {
      let adjustedDate = moment(state.pickupTimeValue.pickup_date).add(1, 'day');
      dropOffDate = adjustedDate.toDate().toString();

    }

    if (timeOption.is_special_timing) {
      setSpecialTiming(true);
      setIsSpecialTiming(true);

      const value = moment(minDateSpecialTiming()).format('HH:mm');

      setDropoffTimeValue({ ...state.dropoffTimeValue, dropoff_later_datetime: value });

    } else {
      setDropoffTimeValue({
        ...state.dropoffTimeValue,
        // dropoff_type: event.target.value,
        dropoff_date: dropOffDate,
        // dropoff_early_datetime: pickupTimeValue.pickup_later_datetime,
        dropoff_later_datetime: timeOption.later_time
      })
    }




  }


  useEffect(() => {
    updatePickupTime(state.pickupTimeValue);

    // update validate when pick up type not empty
    if (!state.error.pickup_time.type && state.pickupTimeValue.pickup_type !== '') {
      validatePickupTime(state.pickupTimeValue);
    }

    // update validate based on pickup time window
    if (!state.error.pickup_time.window_time && state.pickupTimeValue.pickup_early_datetime !== '' && state.pickupTimeValue.pickup_later_datetime !== '') {
      validatePickupWindowTime(state.pickupTimeValue);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.pickupTimeValue, updatePickupTime, validatePickupTime, validatePickupWindowTime]);

  useEffect(() => {
    updateDropoffTime(state.dropoffTimeValue);

    // update validate when drop off type not empty
    if (!state.error.dropoff_time.type && state.dropoffTimeValue.type !== '') {
      validateDropoffTime(state.dropoffTimeValue);
    }

    // update validate based on dropoff time window
    if (!state.error.dropoff_time.window_time && state.dropoffTimeValue.dropoff_early_datetime !== '' && state.dropoffTimeValue.dropoff_later_datetime !== '') {
      validateDropoffWindowTime(state.dropoffTimeValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.dropoffTimeValue, updateDropoffTime, validateDropoffTime, validateDropoffWindowTime]);



  

  const getDropOff = () => {
    //console.log(userData.availableTimes.dropoff);
    // console.log('************************************');


    // console.log('pickupTimeRadio', pickupTimeRadio);

    const getIndex = parseInt(state.pickupTimeRadio.split('-')[1]);

    // console.log(getIndex);


    if (isNaN(getIndex)) return;

    const dropOffTimes = state.pudoTimes[getIndex].dropoff_time;
    //  console.log('dropofftimes',dropOffTimes);   



    return (dropOffTimes.map((p, i) => {
      // console.log('dropoff time');
      // console.log(p);
      let earlyTime = getDateWithTime(p.later_time);
      // if (p.early_time != '') {
      //   earlyTime = getDateWithTime(p.early_time);
      // }

      const nowMoment = getDateWithTime(state.pickupTimeValue.pickup_later_datetime);
      //const nowMoment = getDateWithTime('11:30');
      const laterMoment = moment(earlyTime);

      // console.log('now moment');
      // console.log(nowMoment);
      // console.log('later moment');
      // console.log(laterMoment);
      const diff = laterMoment.diff(nowMoment, 'minutes');
      // console.log('diff');
      // console.log(diff);
      let disabled = false;
      // console.log('should be disabled: ' + (p.early_time === '' && diff < 240));
      // console.log('should be disabled: ' + (p.early_time !== '' && diff < 30));
      // console.log('should be disabled: ' + (p.early_time !== ''));
      // console.log('should be disabled: ' + ( diff < 30));
      // console.log('should be disabled: ' + (pickupTimeValue.pickup_type === '3'));

      if (!p.is_next_day_do && !p.is_special_timing) {
        if ((p.early_time === '' && diff < 240) || (p.early_time !== '' && diff < 30) || state.pickupTimeValue.pickup_type === '3') {
          disabled = true;
          return null;
        }
      }


      /**
       * Do not include special timing for batch
       */
      if (isBatch && p.is_special_timing) {
        // return null;
      }




      // console.log('picup value');
      // console.log(pickupTimeValue);
      let index = i;
      if (p.index) {
        index = p.index;
      }

      if (p.is_special_timing) {
        return <Flex className='flex-row  '><RadioOption key={'d-' + i} selectedValue={state.dropOffTimeRadio} isDisabled={disabled} value={index + ''} label={p.text} />{state.specialTiming && <DateTimePicker id='dropoff-end-time' defaultValue={minDateSpecialTiming()}
          disabled={false} onChange={(value) => dropoffDatetimeHandle(value, false)} minTime={minDateSpecialTiming()} maxTime={maxDateSpecialTiming()} />}</Flex>
      }

      return <RadioOption key={'d-' + i} selectedValue={state.dropOffTimeRadio} isDisabled={disabled} value={index + ''} label={p.text} />;
    }))
      .filter(e => e !== null);
  }

  const getPickup = () => {
    //console.log('pick up type: ');

    //console.log(pickupTimeValue.pickup_type);


    if (interCity && state.isIntercityDown) {
      return <div>Intercity is not available at the moment.</div>;
    }


    // const pickupTimesCollector = [];


    /**
     * If the pickup location has a custom region for PUDO's set up
     */

    if (state.pudoTimes.length > 0) {
      // console.log('********************************');
      // console.log(userData);


      const customResult = state.pudoTimes



        .map((t, i) => {
          // console.log(t);


          const pickupTime = t.pickup_time[0];

          // console.log(pickupTime);


          if (pickupTime.type !== 3) {
            const earlyTime = getDateWithTime(pickupTime.cut_off_time);
            const nowMoment = moment();
            const laterMoment = moment(earlyTime);

            /**
           * Get the time different from now
           */
            const diff = laterMoment.diff(nowMoment, 'minutes')
            const dayOfWeek = laterMoment.day();
            //  console.log('diff: ', diff);

            // console.log('dayOfWeek', dayOfWeek);

            const integerServicedays = pickupTime.service_days.map(d => parseInt(d));

            // console.log('integerServicedays', integerServicedays);


            let isDaySelectedEnabled = integerServicedays.includes(dayOfWeek);

            // console.log('isDaySelectedEnabled', isDaySelectedEnabled);

            // console.log('local intercity', (pickupTime.delivery_type !== 'Local' && interCity));



            let disabled = diff < 1 || !isDaySelectedEnabled || (pickupTime.delivery_type !== 'Local' && !interCity);

            // console.log('disabled', disabled);


            if (disabled) {
              return null;
            }

            /**
             * The normal radio button options
             */
            if (pickupTime.early_time && pickupTime.later_time) {
              return <RadioOption key={'p-' + i} selectedValue={state.pickupTimeRadio} isDisabled={disabled} value={`c-${i}`} label={`${pickupTime.text}`} />;
            }

            return null;

          } else {
            const nowMoment = moment();
            const selectedDate = moment(state.pickupTimeValue.pickup_date);

            //  console.log('now',nowMoment.day());
            //  console.log('selected', selectedDate.day());
            let selectedDayOfDate = selectedDate.day();

            /**
             * This will handle sundey selection, since sundaqy is ZERO
             */
            if (selectedDate.day() === 0) {
              selectedDayOfDate = 7;
            }
            const diff = selectedDayOfDate - nowMoment.day()
            //  console.log('diff', diff);

            /**
             * When the selected date is not today, we disable rush
             */
            if (diff > 0) {
              return null;
            }

            /**
             * When the distance is greater than user rush distance kms, we disable rush
             */
            // console.log(state);

            if (state.distanceInKm > userData.rush_distance) {
              return null;
            }

            /**
             * No rush on batches
             */
            if (isBatch) {
              return null;
            }

            return <RadioOption key={'p-' + i} selectedValue={state.pickupTimeRadio} value={`c-${i}`} label={pickupTime.text} />;

          }
        })
        .filter(e => e !== null);

      // setPickupTimes(pickupTimesCollector);


      if (customResult.length === 0) {
        return <>No Times Available Based On The Locations And Date Selected</>
      }

      return customResult;
    }
  }

  /**
   * Gets a javascript date combining the selected pickup date and the time passed as parameter
   * @param {string} time 
   * @returns Date
   */
  const getDateWithTime = (time) => {
    let result = moment(state.pickupTimeValue.pickup_date);
    const timeString = moment(time, 'HH:mm');

    result.set({
      hour: timeString.get('hour'),
      minute: timeString.get('minute'),
      second: timeString.get('second')
    });

    const target = result.toDate();
    return target;
  }

  // console.log('pickupTimeValue');
  // console.log(pickupTimeValue);

  const disableSundays = (date) => {
    if (userData.isSundayDeliveryEnabled) {
      return false;
    }
    if (date.getDay() === 0) return true;
  }

  const minDateSpecialTiming = () => {
    /**
    * Get a moment with selected date and pickup later time
    */
    const pickup = moment(getDateWithTime(state.pickupTimeValue.pickup_later_datetime));

    /**
     * Add either local time or intercity time
     */
    pickup.add({ hours: interCity ? userData.intercity_min_special_time : userData.local_min_special_time })

    return pickup.toDate();
  }

  const maxDateSpecialTiming = () => {

    /**
     * Get a moment with selecteddate and pickup later time
     */
    const pickup = moment(getDateWithTime(state.pickupTimeValue.pickup_later_datetime));

    /**
     * Add either local time or intercity time
     */
    pickup.hour(20);

    return pickup.toDate();
  }

  // console.log('pickupdropofftimesection', state);


  return <div>
    <div>
      <SubTitle className="mt-6 mb-1">
        Pickup Time *
        {/* <StyledToolTip
          title={
            <>
              <div>
                For same-day delivery, pickups scheduled after 5pm will be charged an URGENT premium. Otherwise, schedule the pickup for tomorrow or later.
              </div>
            </>
          }
          placement={"top"} arrow>
          <img src={InfoIcon} alt={"premium information"} />
        </StyledToolTip> */}
      </SubTitle>

      {/* Error text about pickup type selection */}
      {!state.error.pickup_time.type &&
        <p className='MuiFormHelperText-root Mui-error Mui-required text-errorRed text-xs'>
          Please Select Your Pickup Type
        </p>
      }

      {/* <FormControl component="fieldset">
        <RadioGroup row value={pickupTimeValue.pickup_type} onChange={pickupOptionHandle}>
          <RadioOption selectedValue={pickupTimeValue.pickup_type} value={pickupOptions.READY_NOW} label={'Ready Now Until'} />
          <RadioOption selectedValue={pickupTimeValue.pickup_type} value={pickupOptions.SCHEDULE} label={'Ready Later'} />
          <RadioOption selectedValue={pickupTimeValue.pickup_type} value={pickupOptions.URGENT} label={'Urgent (2hrs or less from now)'} />
        </RadioGroup>
      </FormControl> */}

      <div className='mt-3'>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3}>
              <StyledDatePicker disableToolbar variant="inline" id="pickup-date" label="Date"
                format="MM-dd-yyyy" value={state.pickupTimeValue.pickup_date} onChange={pickupDateChangeHandle} minDate={state.currentPickupDate}
                shouldDisableDate={disableSundays} />
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <Flex className='flex-col'>
                <InputHeader>Pickup Time Window *</InputHeader>

                <FormControl component="fieldset">
                  <RadioGroup row value="pickup" onChange={pickupTimeHandle}>
                    {getPickup()}
                  </RadioGroup>
                </FormControl>



                {!state.error.pickup_time.window_time &&
                  <p className='MuiFormHelperText-root Mui-error Mui-required text-errorRed text-xs' style={{ marginLeft: '8px', marginTop: '5px' }}>
                    {state.error.pickup_time.window_time_error_text}
                  </p>
                }
              </Flex>
            </Grid>
          </Grid>

        </MuiPickersUtilsProvider>
      </div>
    </div>




    <div >
      <SubTitle className="mt-6 mb-1">
        Drop off Time *
      </SubTitle>

      {/* Error text about pickup type selection */}
      {!state.error.dropoff_time.type &&
        <p className='MuiFormHelperText-root Mui-error Mui-required text-errorRed text-xs'>
          Please Select Your Drop off Type
        </p>
      }



      <RadioGroup className="w-full" value="dropoff" onChange={dropOffTimeHandle}>
        {getDropOff()}
      </RadioGroup>
    </div>
    <GenericModal
      content={state.intercityContent}
      contentLabel={'Notification'}
      modalIsOpen={state.isModalOpen}
      setModalIsOpen={setIsModalOpen}
    />
  </div >;
}

const mapStateToProps = (state) => ({
  dropoff_value: {
    dropoff_type: state.deeleeoReducer.dropoff_type,
    dropoff_date: state.deeleeoReducer.dropoff_date !== '' ? state.deeleeoReducer.dropoff_date : moment().toDate().toString(),
    dropoff_early_datetime: state.deeleeoReducer.dropoff_early_datetime,
    dropoff_later_datetime: state.deeleeoReducer.dropoff_later_datetime
  },
  pickup_value: {
    pickup_type: state.deeleeoReducer.pickup_type,
    pickup_date: state.deeleeoReducer.pickup_date !== '' ? state.deeleeoReducer.pickup_date : moment().toDate().toString(),
    pickup_early_datetime: state.deeleeoReducer.pickup_early_datetime,
    pickup_later_datetime: state.deeleeoReducer.pickup_later_datetime
  },
  validation: {
    pickup_time: state.validationReducer.pickup_time,
    dropoff_time: state.validationReducer.dropoff_time,
  },
  deeleeo_data: state.deeleeoReducer,
  userData: state.userReducer,
  pickupData: state.pickupDropoffReducer.pickup_data,
  dropoffData: state.pickupDropoffReducer.dropoff_data,

});

const mapDispatchToProps = (dispatch) => ({
  updatePickupTime: (pickup_value) => dispatch(updatePickupTime(pickup_value)),
  updateDropoffTime: (dropoff_value) => dispatch(updateDropoffTime(dropoff_value)),
  validatePickupTime: (data) => dispatch(validatePickupTime(data)),
  validateDropoffTime: (data) => dispatch(validateDropoffTime(data)),
  validatePickupWindowTime: (data) => dispatch(validatePickupWindowTime(data)),
  validateDropoffWindowTime: (data) => dispatch(validateDropoffWindowTime(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(PickupDropoffTimeSection);
